import { render, staticRenderFns } from "./ClosedProducts.vue?vue&type=template&id=68eacd64&"
import script from "./ClosedProducts.vue?vue&type=script&lang=js&"
export * from "./ClosedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports